import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import mixins from '../../assets/styles/mixins.scss';

const ListButton = styled(Button)({
  '&&': {
    borderRadius: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    justifyContent: 'flex-start',
    width: '100%',
    padding: 0,
    minHeight: 'auto',
    textAlign: 'left',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
});

const ButtonLabel = styled('span')({
  '&&': {
    width: '100%',
    display: 'flex',
    alignItems: 'inherit',
    justifyContent: 'inherit'
  }
});

const ListItem = styled('div')({
  '&&': {
    backgroundColor: '#f6f6fb', // var(--color-non-interactive-background-secondary)
    borderRadius: 8,
    border: '1px solid transparent', // default border-color transparent
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    alignItems: 'flex-start',
    width: '100%',
    boxSizing: 'border-box'
  }
});

const Inner = styled('div')({
  '&&': {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%'
  }
});

const Header = styled('div')({
  '&&': {
    display: 'flex',
    flexDirection: 'row',
    gap: 17,
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: 20
  }
});

const Topic = styled(Typography)({
  '&&': {
    color: '#171717',
    fontFamily: "'PlusJakartaSans-SemiBold', sans-serif",
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center'
  }
});

const List2 = styled('div')({
  '&&': {
    padding: '8px 0',
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    overflow: 'hidden'
  }
});

const LabelStatic = styled('div')({
  '&&': {
    backgroundColor: '#ffebd6',
    borderRadius: 4,
    padding: '0 2px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  }
});

const Label = styled('div')({
  '&&': {
    padding: '0 4px 2px 4px',
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
    height: 20
  }
});

const Badge = styled(Typography)({
  '&&': {
    color: mixins.accentBrown,
    textAlign: 'center',
    fontFamily: "'PlusJakartaSans-Medium', sans-serif",
    fontSize: 12,
    lineHeight: '20px',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const ReviewList = ({
  list,
  onDifficultTopicClick,
  assignmentId,
  isStudentView = false
}) => (
  <>
    {list.map((item, idx) => (
      <ListButton
        key={idx}
        onClick={() => onDifficultTopicClick({ ...item, assignmentId, isStudentView })}
      >
        <ButtonLabel>
          <ListItem>
            <Inner>
              {item.topic && (
              <Header>
                <Topic>{item.topic}</Topic>
              </Header>)
                }
              <List2>
                {item.badges.map((badgeText, bidx) => (
                  <LabelStatic key={bidx}>
                    <Label>
                      <Badge>{badgeText}</Badge>
                    </Label>
                  </LabelStatic>
                ))}
              </List2>
            </Inner>
          </ListItem>
        </ButtonLabel>
      </ListButton>
    ))}
  </>
);

ReviewList.propTypes = {
  list: PropTypes.array,
  onDifficultTopicClick: PropTypes.func,
  assignmentId: PropTypes.number,
  isStudentView: PropTypes.bool
};

ReviewList.defaultProps = {
  list: [],
  onDifficultTopicClick: () => {},
  assignmentId: 0,
  isStudentView: false
};

export default ReviewList;
